import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTrendingDownSmall = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.5 12L8.5 6L6 8.5L1.5 4M14.5 12V8M14.5 12H10.5", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgTrendingDownSmall);
const Memo = memo(ForwardRef);
export default Memo;
